import React from "react";
import ReactPlayer from "react-player";
import car from "../../images/icons/car.png";
import smile from "../../images/icons/smile.png";
import users from "../../images/icons/users.png";
import thumbail from "../../images/logo/logo_aqua.svg";
import img1 from "../../images/p1.jpg";
import img2 from "../../images/p2.jpg";
import img3 from "../../images/p3.jpg";
import img4 from "../../images/p4.jpg";
import bgImg from "../../images/pedagogique.jpg";
import PedagogiqueCard from "../Cards/PedagogiqueCard";
import HomeLogo from "../HomeSection/HomeLogo";
import { Button } from "../ui/button";
import PedagoqiueStatsSection from "./PedagoqiueStatsSection";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import espace_pedagogique3 from "../../images/espace_pedagogique3.jpg";
import espace_pedagogique4 from "../../images/espace_pedagogique4.jpg";
import espace_pedagogique2 from "../../images/espace_pedagogique2.jpg";
import espace_pedagogique from "../../images/espace_pedagogique.jpg";
import waterImg from "../../images/waterglas.png";
import { Card, CardContent } from "../ui/card";
import { Mail } from "lucide-react";

const data = [
  {
    id: 1,
    title:
      "Des élèves de CE2 découvrent le cycle de l'eau à travers des maquettes interactives.",
    image: img1,
  },
  {
    id: 2,
    title:
      "Atelier pratique sur la filtration de l'eau avec des élèves de CM1.",
    image: img2,
  },
  {
    id: 3,
    title:
      "Des élèves de CE2 découvrent le cycle de l'eau à travers des maquettes interactives.",
    image: img3,
  },
  {
    id: 4,
    title:
      "Atelier pratique sur la filtration de l'eau avec des élèves de CM1.",
    image: img4,
  },
];

const images = [
  { id: 1, img: espace_pedagogique, alt: "Educational icons for water cycle" },
  { id: 2, img: espace_pedagogique2, alt: "Glass of water illustration" },
  { id: 3, img: espace_pedagogique3, alt: "Glass of water illustration" },
  { id: 4, img: espace_pedagogique4, alt: "Glass of water illustration" },
];

const PedagogiqueSection = () => {
  return (
    <div>
      <section
        className="p-4 text-center sm:p-6 md:p-10 lg:p-20 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-white sm:text-2xl md:text-3xl">
          Espace pédagogique et visites scolaires
        </h1>
        <p className="max-w-3xl mx-auto mt-4 text-base text-white">
          Grâce à la rénovation de l’usine Carré de Réunion en 2017, un espace
          pédagogique accueille des classes scolaires pour des visites
          enrichissantes sur le “Cycle de l’eau”. <br />
          Découvrez comment en profiter !
        </p>
      </section>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <p className="text-base">
          L’usine Carré de Réunion, récemment rénovée, comporte désormais un
          espace pédagogique qui fait le bonheur des petits comme des grands !
          Conçu pour informer le public scolaire sur le{" "}
          <span className="font-bold text-primary">cycle de l’eau</span> et le
          sensibiliser à cette ressource rare, il regorge d’activités ludiques
          et pédagogiques :{" "}
          <span className="text-primary">ateliers pratiques</span>,{" "}
          <span className="text-primary">expériences participatives</span>,{" "}
          <span className="text-primary">tablette interactive</span>… Ouvert au
          printemps 2018, il a déjà accueilli de nombreuses classes, pour la
          plus grande joie des élèves.
        </p>

        <h2 className="mt-10 text-xl font-bold text-center text-black sm:mt-8">
          Quelles classes sont concernées ?
        </h2>

        <div className="py-6 bg-white sm:py-8">
          <div className="flex flex-col items-center max-w-4xl gap-6 mx-auto md:flex-row">
            <div className="overflow-hidden rounded-lg w-[450px] h-[260px]">
              <ReactPlayer
                playing={false}
                url="https://www.youtube.com/watch?v=q4Ahma5TYIs"
                width="100%"
                height="100%"
              />
            </div>

            <div className="w-full md:w-1/2">
              <p className="mb-4 text-base text-black">
                L’espace est destiné aux classes élémentaires (CP à CM2), avec
                animations et conférences adaptées.
              </p>
              <p className="mb-4 text-base text-black">
                Nos activités sont conçues pour correspondre aux programmes
                scolaires et offrir une expérience éducative enrichissante sur
                le thème de l’eau.
              </p>
              <div className="flex flex-wrap gap-2">
                {["CP", "CE1", "CE2", "CM1", "CM2"].map((level) => (
                  <span
                    key={level}
                    className="px-3 py-1 text-base font-medium rounded-full text-secondary bg-third"
                  >
                    {level}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mt-20">
          <h2 className="mb-6 text-xl font-bold text-center text-black">
            Galerie d’images
          </h2>
          <Carousel opts={{ align: "start", loop: true }} className="w-full">
            <CarouselContent>
              {images.map((item) => (
                <CarouselItem key={item.id}>
                  <div className="flex items-center justify-center   bg-gray-200 rounded-lg sm:h-64 md:h-[30rem]">
                    <img
                      src={item.img}
                      alt={item.alt}
                      className=" w-full h-full rounded-lg"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full  *: left-2 sm:left-4 top-1/2 hover:bg-teal-600" />
            <CarouselNext className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full   right-2 sm:right-4 top-1/2 hover:bg-teal-600" />
          </Carousel>
        </div>

        <div className="py-6 mt-20 bg-white sm:py-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl font-bold text-center text-black ">
              Coût de la visite
            </h2>
            <p className="mb-6 text-center text-neutral-400">
              Cout  changer par modalités d’inscription
            </p>
            <div className="flex flex-col gap-6 md:flex-row">
              <div className="flex-1 border border-gray-200 rounded-lg shadow-sm">
                <div className="py-2 text-base font-semibold text-center text-white rounded-t-lg bg-secondary">
                  Visite Gratuite
                </div>
                <div className="p-4 text-center sm:p-6">
                  <p className="mb-4 text-base text-gray-700">
                    Pour chaque tranche de 5 000 habitants d’une commune membre
                    d’Aquavesc ou Hydreaulys, une visite est offerte.
                  </p>
                  <span className="inline-block px-3 py-1 text-base font-medium text-black rounded-full bg-third">
                    Offre renouvelée chaque année
                  </span>
                </div>
              </div>
              <div className="flex-1 border border-gray-200 rounded-lg shadow-sm">
                <div className="py-2 text-base font-semibold text-center text-white rounded-t-lg bg-secondary">
                  50% Pris en charge
                </div>
                <div className="p-4 text-center sm:p-6">
                  <p className="text-base text-gray-700">
                    Au-delà de l’offre gratuite,{" "}
                    <span className="font-bold">50%</span> de la visite sont
                    financés par Aquavesc ou Hydreaulys. Le reste est à la
                    charge de l’école.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 bg-white sm:py-8">
          <p className="text-base text-center">
            Pour plus d'informations sur les tarifs et les disponibilités,
            n'hésitez pas à nous contacter.
          </p>
          <div className="flex justify-center mt-4">
            <Button>Contactez-nous</Button>
          </div>
          <div className="flex justify-center mt-6">
            <HomeLogo className="h-auto max-w-xs sm:max-w-sm" />
          </div>
        </div>
      </div>

      <div className="w-full">
        <PedagoqiueStatsSection img1={car} img2={smile} img3={users} />
      </div>

      <div className="container mx-auto">
        <div className="max-w-6xl px-4 mx-auto mt-6">
          <div className="p-4 text-sm text-gray-700 border border-orange-500 rounded-lg">
            <p>
              <span className="font-semibold text-orange-500">
                {">_"} Avertissement
              </span>
            </p>
            <p className="text-orange-500">
              Les infrastructures industrielles de la station de traitement de
              l’eau ne sont pas ouvertes au public. Les visites se déroulent
              exclusivement dans l’espace pédagogique aménagé à cet effet.
            </p>
          </div>
        </div>
        <div className="mb-5 bg-white">
          <h2 className="mt-16 text-xl font-bold text-center text-black">
            Qui dois-je contacter ?
          </h2>
          <div className="flex flex-wrap justify-center gap-6 mt-16">
            <div>
              <Card className="bg-[#E6E6E666]">
                <CardContent>
                  <p className="mt-5 font-bold">Visites pédagogiques</p>
                  <p className="mt-5 text-sm">
                    Une adresse mail spécifique aux visites pédagogiques vous
                    permettra de formuler vos souhaits ou nous poser vos
                    dernières questions. Nous vous recontacterons rapidement :
                  </p>

                  <Card className="mt-4">
                    <CardContent>
                      <div className="flex items-center mt-5 space-x-5">
                        <div>
                          <Mail className="w-10 h-10 text-primary" />{" "}
                        </div>
                        <div>
                          <p className="font-bold ">Anna Chognard</p>
                          <p className="text-sm ">anna.chognard@pikpik.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PedagogiqueSection;
